import { RouteHandler } from '@whitetail/buckshot/scripts/buckshot-routes';
import $events from '@whitetail/buckshot/scripts/buckshot-events';
import $store from '@whitetail/buckshot/scripts/buckshot-store';
import $ from '@whitetail/buckshot/scripts/buckshot-dom';

function setOptions($el, options) {
    $el.html(options.map((option) => `<option value="${option.id}">${option.name}</option>`).join(''));
}

export default new RouteHandler({
    init() {
        const counties = $store.get('counties');
        const $countySelect = $(':county');

        setOptions($countySelect, counties.Alabama);

        $events.on(':state', 'change', async (e) => {
            setOptions($countySelect, counties[e.target.value]);
        });
    },
});